import React, { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import TableView from "./TableView";
import GraphView from "./GraphView";

function HistoryData({ fguid, vehicle }) {
  const [startDate, setStartDate] = useState("2025-04-15T10:00");
  const [endDate, setEndDate] = useState("2025-05-15T15:59");
  const [rawData, setRawData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [interval, setInterval] = useState("all");
  const [view, setView] = useState("table"); // 'table' or 'graph'

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "https://icloud.assetscontrols.com:3443/OpenApi/LBS",
        {
          FAction: "QueryLBSTrackListByFGUID",
          FTokenID: "3585535a-137c-499e-82ad-af9feff7d8e7",
          FGUID: fguid,
          FType: "2",
          FStartTime: startDate.replace("T", " ") + ":00",
          FEndTime: endDate.replace("T", " ") + ":59",
          FAssetTypeID: "400",
          FLanguage: "0",
          FDateType: 0,
        }
      );

      if (response.data?.Result === 200) {
        setRawData(response.data.FObject);
        filterByInterval(interval, response.data.FObject);
      } else {
        alert("Error: " + response.data.Message);
      }
    } catch (error) {
      console.error("Request failed", error);
      alert("Failed to fetch data");
    }
    setLoading(false);
  };

  const filterByInterval = (type, dataSource = rawData) => {
    setInterval(type);

    if (type === "all") {
      setFilteredData(dataSource);
      return;
    }

    const grouped = {};

    dataSource.forEach((item) => {
      const time = dayjs(item.GT);
      let key;

      switch (type) {
        case "day":
          key = time.format("YYYY-MM-DD");
          break;
        case "hour":
          key = time.format("YYYY-MM-DD HH");
          break;
        case "minute":
          key = time.format("YYYY-MM-DD HH:mm");
          break;
        case "15s":
          key = time.format("YYYY-MM-DD HH:mm:ss").slice(0, 17); // first 17 chars: up to nearest 15s-ish
          break;
        default:
          key = "all";
      }

      if (!grouped[key]) {
        grouped[key] = {
          count: 0,
          sumFV1: 0,
          example: item, // Save one item for static fields
        };
      }

      grouped[key].sumFV1 += parseFloat(item.FV1) || 0;
      grouped[key].count += 1;
    });

    const averagedData = Object.values(grouped).map((group) => ({
      ...group.example,
      FV1: (group.sumFV1 / group.count).toFixed(2),
    }));

    setFilteredData(averagedData);
  };

  return (
    <div className="p-4 space-y-4">
      <div className="flex flex-col sm:flex-row gap-4">
        <div>
          <label>Start Date:</label>
          <input
            type="datetime-local"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div>
          <label>End Date:</label>
          <input
            type="datetime-local"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <button
          onClick={fetchData}
          className="moButtons bg-blue-500 text-white px-4 py-1 rounded"
        >
          {loading ? "Loading..." : "Fetch Data"}
        </button>
      </div>

      <div className="flex gap-2 flex-wrap">
        {["all", "day", "hour", "minute", "15s"].map((intv) => (
          <button
            key={intv}
            onClick={() => filterByInterval(intv)}
            className={`moButtons px-3 py-1 border rounded ${
              interval === intv ? "bg-blue-600 text-white" : "bg-gray-100"
            }`}
          >
            {intv}
          </button>
        ))}
        <button
          onClick={() => setView("table")}
          className={`moButtons px-3 py-1 rounded border ${
            view === "table" ? "bg-green-600 text-white" : "bg-gray-100"
          }`}
        >
          Show Table
        </button>
        <button
          onClick={() => setView("graph")}
          className={`moButtons px-3 py-1 rounded border ${
            view === "graph" ? "bg-purple-600 text-white" : "bg-gray-100"
          }`}
        >
          Show Graph
        </button>
      </div>
      <div>Data for vehicle : {vehicle}</div>

      {filteredData.length === 0 ? (
        <div className="text-center text-gray-500 mt-4 text-xl">
          📭 No data to display
        </div>
      ) : view === "table" ? (
        <TableView data={filteredData} />
      ) : (
        <GraphView data={filteredData} />
      )}
    </div>
  );
}

export default HistoryData;
